import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ae9876c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "companies" }
const _hoisted_2 = { class: "flex itemscenter justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1))
const _hoisted_4 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_5 = { class: "flex justify-end mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col items-center justify-center mt-3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none mt-1 text-sm text-gray-400" }, " Загрузка данных... ", -1))
const _hoisted_11 = {
  key: 0,
  style: {"width":"300px","white-space":"initial"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_companies_import = _resolveComponent("companies-import")!
  const _component_change_accountant = _resolveComponent("change-accountant")!
  const _component_companies_actions = _resolveComponent("companies-actions")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!
  const _component_verification_enable = _resolveComponent("verification-enable")!
  const _component_billing = _resolveComponent("billing")!
  const _component_companies_generate_contract = _resolveComponent("companies-generate-contract")!
  const _component_companies_payers = _resolveComponent("companies-payers")!
  const _component_companies_reset = _resolveComponent("companies-reset")!
  const _component_companies_managers = _resolveComponent("companies-managers")!
  const _component_company_form = _resolveComponent("company-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_loader = _resolveComponent("loader")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_companies_list_actions = _resolveComponent("companies-list-actions")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.import_state.is_opened)
      ? (_openBlock(), _createBlock(_component_companies_import, {
          key: 0,
          onImported: _ctx.onImported,
          onCancel: _ctx.onCancelImport
        }, null, 8, ["onImported", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.change_accountant_state.is_opened)
      ? (_openBlock(), _createBlock(_component_change_accountant, {
          key: 1,
          loading: _ctx.change_accountant_state.is_loading,
          onCancel: _ctx.closeChangeAccountant,
          onChangeStandart: _ctx.changeAccountant,
          onChangeIndividual: _ctx.changeIndividualAccountant
        }, null, 8, ["loading", "onCancel", "onChangeStandart", "onChangeIndividual"]))
      : _createCommentVNode("", true),
    (_ctx.set_client_state.is_opened)
      ? (_openBlock(), _createBlock(_component_companies_actions, {
          key: 2,
          loading: _ctx.set_client_state.is_loading,
          "initial-value": _ctx.set_client_state.info,
          onSet: _ctx.setClient,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.set_client_state.is_opened = false))
        }, null, 8, ["loading", "initial-value", "onSet"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.apply_state.is_opened)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            class: "large",
            title: "Присвоение бухгалтера",
            "confirm-button-text": "Присвоить",
            loading: _ctx.apply_state.is_loading,
            onCancel: _ctx.closeApplyModal,
            onConfirm: _ctx.applyAccountant
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_select, {
                "can-deselect": "",
                placeholder: "Выберите бухгалтера",
                value: _ctx.apply_state.accountant_id,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.apply_state.accountant_id) = $event)),
                "is-invalid": _ctx.apply_form$.accountant_id.$error,
                "validation-errors": _ctx.apply_form$.accountant_id.$errors,
                loading: _ctx.data_state.accountants.is_loading,
                options: _ctx.data_state.accountants.list,
                failed: _ctx.data_state.accountants.is_failed,
                "error-text": "При получении списка бухгалтеров произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name",
                "infinite-scroll": "",
                searchable: false,
                onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadAccountants(_ctx.data_state.accountants.pagination.current_page))),
                onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreAccountants(_ctx.data_state.accountants.pagination.current_page + 1)))
              }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"])
            ]),
            _: 1
          }, 8, ["loading", "onCancel", "onConfirm"]))
        : _createCommentVNode("", true),
      (_ctx.verification_state.is_opened)
        ? (_openBlock(), _createBlock(_component_verification_enable, {
            key: 1,
            company: _ctx.verification_state.company,
            onCancel: _ctx.onCancelEnableVerification,
            onEnabled: _ctx.onVerificationEnabled
          }, null, 8, ["company", "onCancel", "onEnabled"]))
        : _createCommentVNode("", true),
      (_ctx.billing_state.is_opened)
        ? (_openBlock(), _createBlock(_component_billing, {
            key: 2,
            company: _ctx.billing_state.company,
            onCancel: _ctx.toggleBilling,
            onSubmit: _ctx.onSubmitBilling
          }, null, 8, ["company", "onCancel", "onSubmit"]))
        : _createCommentVNode("", true),
      (_ctx.generate_state.is_opened)
        ? (_openBlock(), _createBlock(_component_companies_generate_contract, {
            key: 3,
            loading: _ctx.generate_state.is_loading,
            onCancel: _ctx.closeGenerateContract,
            onGenerate: _ctx.generateContract
          }, null, 8, ["loading", "onCancel", "onGenerate"]))
        : _createCommentVNode("", true),
      (_ctx.payers_state.is_opened)
        ? (_openBlock(), _createBlock(_component_companies_payers, {
            key: 4,
            loading: _ctx.payers_state.is_loading,
            "selected-companies": _ctx.payers_state.payer_company_ids,
            "company-id": _ctx.payers_state.company_id,
            onCancel: _ctx.togglePayers,
            onPayers: _ctx.handlePayers
          }, null, 8, ["loading", "selected-companies", "company-id", "onCancel", "onPayers"]))
        : _createCommentVNode("", true),
      (_ctx.reset_state.is_opened)
        ? (_openBlock(), _createBlock(_component_companies_reset, {
            key: 5,
            loading: _ctx.payers_state.is_loading,
            onCancel: _ctx.toggleReset,
            onReset: _ctx.handleReset
          }, null, 8, ["loading", "onCancel", "onReset"]))
        : _createCommentVNode("", true),
      (_ctx.managers_state.is_opened)
        ? (_openBlock(), _createBlock(_component_companies_managers, {
            key: 6,
            loading: _ctx.managers_state.is_loading,
            onCancel: _ctx.toggleManagers,
            onManagers: _ctx.handleManagers
          }, null, 8, ["loading", "onCancel", "onManagers"]))
        : _createCommentVNode("", true),
      (_ctx.actions_state.is_actions_opened)
        ? (_openBlock(), _createBlock(_component_company_form, {
            key: 7,
            "is-create": _ctx.actions_state.is_create,
            "is-update": _ctx.actions_state.is_update,
            "initial-value": _ctx.actions_state.initial_value,
            loading: _ctx.actions_state.is_actions_loading,
            onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
            onCreate: _ctx.createCompany,
            onUpdate: _ctx.updateCompany
          }, null, 8, ["is-create", "is-update", "initial-value", "loading", "onCreate", "onUpdate"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_page_title, { title: "Компании" }),
              _createElementVNode("div", null, [
                (_ctx.account.havePermissions(['company-import', 'all-root-permission']))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "primary small mr-2",
                      hint: "Импорт контрагентов",
                      onClick: _ctx.onImport
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanChangeAccountant)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 1,
                      class: "primary small mr-2",
                      onClick: _ctx.openChangeAccountant
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Смена отв. бухгалтера ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanCreateCompany)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 2,
                      class: "primary small mr-2",
                      onClick: _ctx.startCreate
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить компанию ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  class: "primary small mr-2",
                  onClick: _ctx.exportExcel,
                  loading: _ctx.state.is_loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скачать в Excel ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                (_ctx.isCanChangeManager)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 3,
                      class: "primary small",
                      onClick: _ctx.toggleManagers
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Сменить менеджера ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("form", {
              class: "flex flex-col px-6 py-4 border bg-white mt-6",
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.loadCompanies(1)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_the_input, {
                  value: _ctx.state.search_query,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.search_query) = $event)),
                  placeholder: "Поиск по названию"
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state.bin,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.bin) = $event)),
                  placeholder: "Поиск по БИН"
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state.createdAtFrom,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.createdAtFrom) = $event)),
                  placeholder: "Дата от",
                  type: "date"
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state.createdAtTo,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.createdAtTo) = $event)),
                  placeholder: "Дата до",
                  type: "date"
                }, null, 8, ["value"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  value: _ctx.state.managerIds,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.managerIds) = $event)),
                  multiselect: "",
                  placeholder: "Менеджер",
                  loading: _ctx.data_state.managers.is_loading,
                  options: _ctx.data_state.managers.list,
                  failed: _ctx.data_state.managers.is_failed,
                  "error-text": "При получении списка менеджеров произошла ошибка",
                  onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadManagers(_ctx.data_state.managers.pagination.current_page))),
                  onSearch: _ctx.searchManagers,
                  onOptionBySearch: _ctx.unshiftFoundManager,
                  onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (
                            _ctx.loadMoreManagers(_ctx.data_state.managers.pagination.current_page + 1)
                        )),
                  "infinite-scroll": "",
                  class: "mt-2"
                }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  value: _ctx.state.shipmentTariffId,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.shipmentTariffId) = $event)),
                  placeholder: "Тариф",
                  loading: _ctx.data_state.tariffs.is_loading,
                  options: _ctx.data_state.tariffs.list,
                  failed: _ctx.data_state.tariffs.is_failed,
                  "error-text": "При получении списка тарифов произошла ошибка",
                  onRefresh: _ctx.loadTariffs,
                  searchable: false,
                  class: "mt-2"
                }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
                _createVNode(_component_the_select, {
                  placeholder: "Приоритет",
                  value: _ctx.state.priorityEnabled,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.priorityEnabled) = $event)),
                  options: _ctx.PRIORITY_OPTIONS,
                  "can-deselect": "",
                  "select-by": "value"
                }, null, 8, ["value", "options"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  value: _ctx.state.companySourceIds,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.companySourceIds) = $event)),
                  multiselect: "",
                  placeholder: "Признак",
                  loading: _ctx.data_state.companySources.is_loading,
                  options: _ctx.data_state.companySources.list,
                  failed: _ctx.data_state.companySources.is_failed,
                  "error-text": "При получении списка признаков произошла ошибка",
                  onRefresh: _ctx.loadCompanySources
                }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
                _createVNode(_component_checkbox, {
                  value: _ctx.state.billingEnabled,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.billingEnabled) = $event)),
                  label: "Биллинг",
                  "return-integer": ""
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_the_button, {
                  class: "second text small mr-3",
                  disabled: _ctx.state.is_loading,
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createTextVNode(" Сбросить ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  loading: _ctx.state.is_loading,
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createTextVNode(" Поиск ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.state.companies.is_loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_10
                  ]))
                : (
                        _ctx.state.companies.is_failed && !_ctx.state.companies.failure.error_state.is_cancel
                    )
                  ? (_openBlock(), _createBlock(_component_failed_fetch, {
                      key: 1,
                      loading: _ctx.state.companies.is_loading,
                      text: "При получении списка компаний произошла ошибка",
                      "error-message": _ctx.state.companies.failure.error_state.message,
                      "error-url": _ctx.state.companies.failure.error_state.url,
                      "error-status": _ctx.state.companies.failure.error_state.status,
                      onRefresh: _cache[17] || (_cache[17] = ($event: any) => (_ctx.loadCompanies(_ctx.state.companies.pagination.current_page)))
                    }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
                  : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                      key: 2,
                      loading: _ctx.state.companies.is_loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_table, {
                          loading: _ctx.state.companies.is_loading,
                          columns: _ctx.CompaniesColumns,
                          rows: _ctx.state.companies.list,
                          "with-limit": "",
                          "pagination-limit": _ctx.state.limit,
                          "pagination-total-items": _ctx.state.companies.pagination.total_items,
                          "pagination-current-page": _ctx.state.companies.pagination.current_page,
                          "pagination-total-pages": _ctx.state.companies.pagination.total_pages,
                          onChangePage: _ctx.loadCompanies,
                          onChangeLimit: _ctx.onLimitChange,
                          "is-columns-modal": ""
                        }, {
                          td: _withCtx(({ row, column }) => [
                            (column.key === 'name' && row.name)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/companies/${row.id}`,
                                  class: "text-blue-500"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (column.key === 'status' && row.status_id)
                                ? (_openBlock(), _createBlock(_component_cheap, {
                                    key: 1,
                                    class: _normalizeClass(_ctx.getStatusClass(row.status_id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(row.status), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                : (column.key === 'billing')
                                  ? (_openBlock(), _createBlock(_component_cheap, {
                                      key: 2,
                                      class: _normalizeClass(['small', { green: row.billing_enabled }])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Биллинг " + _toDisplayString(row.billing_enabled ? 'включен' : 'выключен'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]))
                                  : (row.manager && column.key === 'manager')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createTextVNode(_toDisplayString(row.manager.name), 1)
                                      ], 64))
                                    : (column.key === 'created_at')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                          _createTextVNode(_toDisplayString(_ctx.moment(row.created_at).format('DD.MM.YYYY HH:MM')), 1)
                                        ], 64))
                                      : (column.key === 'contractServices')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                            (row.contractServices && row.contractServices.length > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(row.contractServices.join(', ')), 1))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createTextVNode(" - ")
                                                ], 64))
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                            _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                          ], 64))
                          ]),
                          actions: _withCtx(({ row }) => [
                            _createVNode(_component_companies_list_actions, {
                              item: row,
                              onUpdate: _ctx.startUpdate,
                              onGenerate: ($event: any) => (_ctx.openGenerateContract(row.id)),
                              onGenerateTranscript: _ctx.generateCompanyTranscript,
                              onPayers: _ctx.togglePayers,
                              onReset: _ctx.onToggleReset,
                              onEnableVerification: _ctx.onStartEnableVerification,
                              onVerificationDisabled: _ctx.onVerificationDisabled,
                              onSmsActivated: _ctx.onSmsActivated,
                              onSmsDisabled: _ctx.onSmsDisabled,
                              onApply: _ctx.openApplyModal,
                              onSetClient: _ctx.onSetClient,
                              onBilling: ($event: any) => (_ctx.toggleBilling(row)),
                              onRefresh: _ctx.loadCompanies
                            }, null, 8, ["item", "onUpdate", "onGenerate", "onGenerateTranscript", "onPayers", "onReset", "onEnableVerification", "onVerificationDisabled", "onSmsActivated", "onSmsDisabled", "onApply", "onSetClient", "onBilling", "onRefresh"])
                          ]),
                          _: 1
                        }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
            ])
          ], 64))
    ])
  ], 64))
}